import React from "react";
import './nav.css';

const Nav = () =>{
  return(
    <nav className="site-nav">
      <ul>
        <li className = "site-logo">
          <i className = "fas fa-tshirt"/>
          <p className = "site-title">Macrina</p>
        </li>
        <li>Home</li>
        <li>Store</li>
        <li onClick={"https://twitter.com/jeffubayi"}>Twitter</li>
        <li key={"https://www.instagram.com/macrina__/"}>Instagram</li>
      </ul>
    </nav>

  );

}
export default Nav;

// export default class Nav extends React.Component {
//   render() {
//     return (
//       <nav className="site-nav">
//         <ul>
//           <li className="site-logo">
//             <i className="fas fa-tshirt" />
//             <p className="site-title">Macrina</p>
//           </li>
//           <li>Home</li>
//           <li>Store</li>
//           <li key={"https://twitter.com/jeffubayi"}>Twitter</li>
//           <li key={"https://www.instagram.com/macrina__/"}>Instagram</li>
//         </ul>
//       </nav>
//     );
//   }
// }



// WEBPACK FOOTER //
// ./src/components/nav/nav.js